import { Reservations } from '@components';

import './style.scss';

export function ReservationsPage() {
  return (
    <div className="reservations-page">
      <div className="reservations-page__main">
        <Reservations />
      </div>
    </div>
  );
}
